<template>
  <div class="memberList-detail">
    <div class="msg">
      <h1>详情</h1>
      <ul>
        <li>
          <span>姓名：</span>
          <span>{{detailData.userName}}</span>
        </li>
        <li>
          <span>手机号：</span>
          <span>{{detailData.userPhone}}</span>
        </li>
        <li>
          <span>性别：</span>
          <span>{{detailData.userSex ===  1 ? '男' : '女'}}</span>
        </li>
        <li>
          <span>积分：</span>
          <span>{{detailData.userIntegral}}</span>
        </li>
        <li>
          <span>生日：</span>
          <span>{{detailData.userBirthday}}</span>
        </li>
        <li>
          <span>城市：</span>
          <span>{{detailData.userCity}}</span>
        </li>
        <li>
          <span>Email：</span>
          <span>{{detailData.userEmail}}</span>
        </li>
        <li>
          <span>店铺：</span>
          <span>{{detailData.shopName}}</span>
        </li>
      </ul>
    </div>
    <div class="record">
      <h1>积分记录</h1>
      <el-table
        v-loading="tableLoading"
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
      >
        <el-table-column prop="createTime" label="时间" align="left"></el-table-column>
        <el-table-column prop="integralContent" label="内容" align="left"></el-table-column>
        <el-table-column prop="integralNum" label="积分" align="left"></el-table-column>
      </el-table>
      <pagination
        :current-page="currentPage"
        :page-size="pageSize"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>
<script>
import Pagination from '@/components/Pagination';
import { getUser, getAppIntegralRecordList } from '@/api/prefer';

export default {
  data() {
    return {
      detailData: {},
      tableData: [],
      tableLoading: false,
      loading: false,
      currentPage: 1,
      pageSize: 10,
      total: 1,
    };
  },
  components: {
    Pagination,
  },
  mounted() {
    this.getUser();
    this.getAppIntegralRecordList();
  },
  methods: {
    // 获取详情
    getUser() {
      const { id } = this.$route.query;
      getUser(id).then((res) => {
        if (res.success && res.data) {
          const { userCity, ...rest } = res.data;
          const [provice, city] = userCity.split(',');
          if (provice === city) {
            this.detailData = {
              ...rest,
              userCity: city,
            };
          } else {
            this.detailData = res.data;
          }
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 获取积分记录列表
    getAppIntegralRecordList() {
      this.tableLoading = true;
      const { id } = this.$route.query;
      getAppIntegralRecordList({
        id,
        page: this.currentPage,
        pageSize: this.pageSize,
      }).then((res) => {
        if (res.success) {
          const { list, total } = res.data;
          this.tableData = list;
          this.total = total;
          this.tableLoading = false;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.getAppIntegralRecordList();
    },
    handleCurrentChange(page) {
      this.currentPage = page;
      this.getAppIntegralRecordList();
    },
  },
};
</script>
<style lang="stylus" scoped>
@import '~assets/css/mixins'
.memberList-detail
  .msg
    border-bottom 1px solid #e8e8e8
    padding-bottom 24px
    h1
      margin-bottom 20px
      color rgba(0, 0, 0, 0.85)
      font-weight 700
      font-size 16px
      line-height 1.5
    ul
      flex-row()
      li
        width 25%
        padding-bottom 16px
  .record
    margin-top 30px
    h1
      margin-bottom 16px
      color rgba(0, 0, 0, 0.85)
      font-weight 500
      font-size 16px
</style>
